import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {HeaderService} from '../../core/services/header.service';
import {Title} from '@angular/platform-browser';
import {BaseComponent} from '../../core/base.component';
import {AuthService} from '../../core/security/auth.service';
import {RolesEnum} from '../../core/security/roles.enum';
import {ContactService} from '../contact.service';
import {DuplicateContactModel} from '../../api/models/duplicate-contact-model';
import {MatDialog} from '@angular/material/dialog';
import {DuplicatesEditDialogComponent} from './duplicates-edit-dialog.component';
import { MatCard } from '@angular/material/card';
import { FlexModule } from '@angular/flex-layout';
import { TableModule } from 'primeng/table';
import { PrimeTemplate } from 'primeng/api';
import { NgFor, NgIf } from '@angular/common';
import { Skeleton } from 'primeng/skeleton';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatCheckbox } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { PhoneNumberPipe } from '../../core/pipes/phone-number.pipe';

@Component({
    selector: 'app-duplicate-contacts-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.scss'],
    standalone: true,
    imports: [
        MatCard,
        FlexModule,
        TableModule,
        PrimeTemplate,
        NgFor,
        NgIf,
        Skeleton,
        MatIconButton,
        MatIcon,
        MatCheckbox,
        FormsModule,
        MatButton,
        PhoneNumberPipe,
    ],
})
export class ContactDuplicatesListComponent extends BaseComponent implements OnInit, OnDestroy, OnChanges {

  @Input() contactType: string;
  @Output() onDuplicatesSelected = new EventEmitter<Array<DuplicateContactModel>>();

  loading = false;
  rowGroupMetadata: any = {};
  duplicatesData: Array<DuplicateContactModel> = [];
  duplicatesLoadingData: Array<DuplicateContactModel> = [];

  isExpanded = false;
  expandedRows: any = {};
  temDataLength = 0;

  tableColumns = [
    {title: 'Name'},
    {title: 'Phone Number'},
    {title: 'Mobile Number'},
    {title: 'Fax Number'},
    {title: 'Email Address'},
    {title: 'Company Name'},
    {title: 'Directory'},
  ];

  detailsUrl: string;

  constructor(route: ActivatedRoute, headerService: HeaderService, titleService: Title, authService: AuthService,
              public contactService: ContactService,
              public dialog: MatDialog) {
    super(route, headerService, titleService, authService);

    for (let i = 0; i < 20; i++) {
      this.duplicatesLoadingData.push({group: i.toString()});
    }

    this.duplicatesData = this.duplicatesLoadingData;

    this.detailsUrl = '/contacts/contact';

    this.editRoles = [RolesEnum.CompanyContact_Edit, RolesEnum.CompanyContact_Delete,
      RolesEnum.PrivateContact_Edit, RolesEnum.PrivateContact_Delete];
    this.deleteRoles = [RolesEnum.CompanyContact_Delete, RolesEnum.PrivateContact_Delete];
  }

  ngOnInit() {
    super.ngOnInit();

    this.loadDuplicates(null);
  }

  expandAll() {
    if (!this.isExpanded) {
      this.duplicatesData.forEach(data => {
        this.expandedRows[data.group] = true;
      });
    } else {
      this.expandedRows = {};
    }
    this.isExpanded = !this.isExpanded;
  }

  onRowExpand() {
    console.log('row expanded', Object.keys(this.expandedRows).length);
    if (Object.keys(this.expandedRows).length === this.temDataLength) {
      this.isExpanded = true;
    }
  }

  onRowCollapse() {
    console.log('row collapsed', Object.keys(this.expandedRows).length);
    if (Object.keys(this.expandedRows).length === 0) {
      this.isExpanded = false;
    }
  }

  async getDuplicateContactsListData() {
    this.duplicatesData = this.duplicatesLoadingData;
    this.loading = true;

    try {
      this.duplicatesData = await this.contactService.getDuplicateUserContactsList(this.contactType);
      this.temDataLength = this.duplicatesData.length;
      this.updateRowGroupMetaData();

      this.expandAll();
    } finally {
      this.loading = false;
    }
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  onSort() {
    this.updateRowGroupMetaData();
  }

  updateRowGroupMetaData() {
    this.rowGroupMetadata = {};

    if (this.duplicatesData) {
      for (let i = 0; i < this.duplicatesData.length; i++) {
        const rowData = this.duplicatesData[i];
        const representativeName = rowData.group;

        if (i === 0) {
          this.rowGroupMetadata[representativeName] = {index: 0, size: 1, allowSelect: true};
        } else {
          const previousRowData = this.duplicatesData[i - 1];
          const previousRowGroup = previousRowData.group;
          if (representativeName === previousRowGroup) {
            this.rowGroupMetadata[representativeName].size++;
          } else {
            this.rowGroupMetadata[representativeName] = {index: i, size: 1, allowSelect: true};
          }
        }
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {

  }

  loadDuplicates($event: any) {
    this.getDuplicateContactsListData().then();
  }

  duplicateSelectionChanged(item: DuplicateContactModel) {
    console.log(item);
    const group = this.rowGroupMetadata[item.group];
    const totalSelected = this.duplicatesData.filter(x => x.selected && x.group === item.group).length;
    group.allowSelect = group.size - totalSelected > 1;

    const selected = this.duplicatesData.filter(x => x.selected);
    this.onDuplicatesSelected.emit(selected);
    console.log('selected records: ' + selected.length);
  }

  editContact(id) {
    const dialogRef = this.dialog.open(DuplicatesEditDialogComponent, {
      height: '90%',
      data: {
        id: id,
      }
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result === 'refresh') {
        await this.getDuplicateContactsListData();
        console.log('end edit');
      }
    });
  }

  selectAllDuplicates(type: string) {
    console.log('select all', type);
    for (const item of this.duplicatesData) {
      item.selected = false;
      this.duplicateSelectionChanged(item);
    }

    if (type === 'first') {
      for (let i = 0; i < this.duplicatesData.length; i++) {
        const item = this.duplicatesData[i];
        const nextItem = this.duplicatesData[i + 1];
        const newGroup = item.group !== nextItem?.group;
        item.selected = !newGroup;

        this.duplicateSelectionChanged(item);
      }
    } else if (type === 'last') {
      for (let i = 0; i < this.duplicatesData.length; i++) {
        const item = this.duplicatesData[i];
        const group = this.rowGroupMetadata[item.group];
        const oldItem = i === 0 ? item : this.duplicatesData[i - 1];

        if (i === 0 || item.group !== oldItem?.group) {
          item.selected = false;
        } else if (group.allowSelect) {
          item.selected = true;
        }

        this.duplicateSelectionChanged(item);
      }
    }
  }
}
